export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-kr_kr@3x.36ca8d93.jpg";